module.exports = __webpack_public_path__ + "2e4974cf92373c793ce44eabb7498026.svg";